<template>
    <section class="addquest">
        <SearchInputTextComponent ref="requestSearchInput"
                                  v-model="searchValue" 
                                  :placeholder="'Wyszukaj osobę...'"
                                  @blured="blured"
                                  @focused="focused"
                                  :width="'100%'"
                                  :withButton="false"/>
        <div class="addquest-autocomplete-list" v-if="showSuggestList"
             @mouseover="mouserOverSuggestList = true"
             @mouseleave="mouserOverSuggestList = false">
            <div class="add-new-guest">
                <button class="
                            addquest-button
                            addquest-button__white"
                        @click="enableAddNewGuestModal">
                    <img src="../../../assets/icons/components/add-user-to-favorite.svg" class="button-image" alt="Dodaj gościa" />
                    Dodaj nowego gościa
                </button>
            </div>
            <LazyList :data="suggestQuestList"
                      :itemsPerRender="7"
                      containerClasses="list"
                      defaultLoadingColor="#222">
                <template v-slot="{item}">
                    <div class="addquest-autocomplete-list-item"
                         :class="{'favorite': item.isFavorite && !item.isUserTemp, 'temporary': item.isUserTemp}">

                        <div class="addquest-autocomplete-list-item-user-data">
                            <div class="addquest-autocomplete-list-item-user-data-username">
                                <div class="addquest-autocomplete-list-item-user-avatar" @click="addParticipantToRequestSpeechList(item.uid, 2)" v-tooltip="'Dodaj do listy dyskutantów'">
                                    <img :src="getUserAvata(item.uid)" class="addquest-autocomplete-list-item-user-avatar-img" />
                                    <div>
                                        <span v-html=item.name></span> <span v-html=item.surname></span>
                                    </div>
                                    <div class="addquest-autocomplete-list-item-user-data-role">
                                        {{item.role}}
                                    </div>
                                </div>

                                <img src="../../../assets/icons/components/star.svg"
                                     alt="Ulubiony użytkownik"
                                     class="user-favourite-icon"
                                     @click="removeParticipantFromFavorite(item.uid)"
                                     v-if="!item.isUserTemp && item.isFavorite" v-tooltip="'Usuń ulubionych'" />

                                <img src="../../../assets/icons/components/star-empty.svg"
                                     alt="Zwykły użytkownik"
                                     class="user-favourite-icon-empty"
                                     @click="addParticipantToFavorite(item.uid)"
                                     v-if="!item.isUserTemp && !item.isFavorite" v-tooltip="'Dodaj do ulubionych'" />

                            </div>

                            <div class="addquest-autocomplete-list-item-user-data-function">
                                <button class="addquest-button addquest-button__white"
                                        v-tooltip="'Dodaj do listy dyskutantów'"
                                        @click="addParticipantToRequestSpeechList(item.uid, 2)">
                                    <img src="../../../assets/icons/components/add-list.svg" alt="Dodaj do listy" class="button-image" />
                                </button>
                                <button class="addquest-button addquest-button__white" v-tooltip="'Dodaj jako AV'" @click="addParticipantToRequestSpeechList(item.uid, 3)">
                                    AV
                                </button>
                                <button class="addquest-button addquest-button__white" v-tooltip="'Dodaj jako WF'" @click="addParticipantToRequestSpeechList(item.uid, 4)">
                                    WF
                                </button>
                                <button class="addquest-button addquest-button__white"
                                        v-tooltip="'Udziel głosu'"
                                        @click="giveParticipantSpeech(item.uid)">
                                    <img src="../../../assets/icons/components/microphone.svg" alt="Udziel głosu" class="button-image" />
                                </button>
                                <button class="addquest-button addquest-button__red"
                                        v-if="item.isUserTemp"
                                        v-tooltip="'Usuń'"
                                        @click="removeParticipant(item.uid)">
                                    <img src="../../../assets/icons/components/delete-point.svg" class="button-image" alt="Usuń" />
                                </button>

                            </div>
                        </div>
                    </div>
                </template>
            </LazyList>
        </div>
        <Transition>
        <AddNewGuestModal v-if="$store.state.interactiveStore.isShowAddNewGuest" />
        </Transition>
    </section>
</template>
<script charset="utf-8">
    import AddNewGuestModal from "./Modals/AddNewGuestModal.vue"
    import LazyList from 'lazy-load-list/vue'
    import SearchInputTextComponent from "../../BasicControls/SearchInputTextComponent.vue"

    export default {
        name: "DiscussionQuestSearcher",
        components: {
            AddNewGuestModal,
            SearchInputTextComponent,
            LazyList
        },
        props: {
            availableQuestList: {
                type: Array,
                required: true,
            },
            currentRequestList: {
                type: Array,
                required: true,
            }
        },
        emits: [
            "addParticipantToRequestSpeechList",
            "giveParticipantSpeech",
            "removeParticipant",
            "addParticipantToFavorite",
            "removeParticipantFromFavorite",
        ],
        watch: {
            searchValue: {
                immediate: true,
                handler(val) {
                    this.suggestQuestList = this.internalAvailableQuestList.map(item => { return { ...item } });
                    this.suggestQuestList = Array.from(this.suggestQuestList.filter(item => {
                        if (this.currentRequestList.includes(e => e.userId === item.uid) > 0)
                            return false;


                        if (item.queryString.indexOf(val.toLowerCase()) !== -1) {
                            if (item.name !== undefined && item.name !== null)
                                item.name = item.name.replace(new RegExp(val, 'gi'), "<span class='highlite'>$&</span>");

                            if (item.surname !== undefined && item.surname !== null)
                                item.surname = item.surname.replace(new RegExp(val, 'gi'), "<span class='highlite'>$&</span>");
                            return true;
                        }

                        return false;
                    }));
                },
            },
            currentRequestList: {
                immediate: true,
                deep: true,
                handler(val) {
                    this.suggestQuestList = [...this.internalAvailableQuestList];

                    this.suggestQuestList = Array.from(this.suggestQuestList.filter(item => {

                        if (val.includes(e => parseInt(e.userId) === parseInt(item.uid)) > 0)
                            return false;

                        return true;
                    }));

                }
            },
            availableQuestList: {
                immediate: true,
                handler(val) {
                    this.internalAvailableQuestList = Array.from(val.map(item => {
                        let newItem = { ...item }
                        newItem.queryString = (`${item.name} ${item.surname}`).toLowerCase()
                        return newItem;
                    }));
                }
            }
        },
        data() {
            return {
                suggestQuestList: [],
                searchValue: "",
                showSuggestList: false,
                mouserOverSuggestList: false,
                internalAvailableQuestList: [],
            }
        },
        methods: {
            getUserAvata(uid) {
                return `https://ssl.esesja.pl/users/${uid}.jpg`;
            },

            focused() {
                this.suggestQuestList = [];
                for (let item of this.internalAvailableQuestList) {
                    if (this.currentRequestList.includes(e => e.userId === item.uid) > 0)
                        continue;

                    this.suggestQuestList.push(item);
                }
                this.showSuggestList = true
            },

            blured() {
                if (!this.mouserOverSuggestList) {
                    this.searchValue = "";
                    this.showSuggestList = false
                }
            },

            giveParticipantSpeech(uid) {
                this.$emit('giveParticipantSpeech', this.getOriginalQuestItem(uid));
                this.showSuggestList = false;
                this.mouserOverSuggestList = false;
                this.searchValue = "";
            },

            addParticipantToRequestSpeechList(uid, type) {
                var data = {
                    participant: this.getOriginalQuestItem(uid),
                    type: type
                };
                this.$emit('addParticipantToRequestSpeechList', data)
                this.showSuggestList = false;
                this.mouserOverSuggestList = false;
                this.searchValue = "";
            },

            removeParticipant(uid) {
                this.$emit('removeParticipant', this.getOriginalQuestItem(uid))
                this.showSuggestList = false;
                this.mouserOverSuggestList = false;
                this.searchValue = "";
            },

            removeParticipantFromFavorite(uid) {
                this.$emit('removeParticipantFromFavorite', this.getOriginalQuestItem(uid))
                this.showSuggestList = false;
                this.mouserOverSuggestList = false;
                this.searchValue = "";

                this.focusInput();

                var r = this.suggestQuestList.filter(x => x.uid == uid);
                if (r != null && r.length > 0) {
                    r[0].isFavorite = false;
                }
            },

            addParticipantToFavorite(uid) {
                this.$emit('addParticipantToFavorite', this.getOriginalQuestItem(uid))
                this.showSuggestList = false;
                this.mouserOverSuggestList = false;
                this.searchValue = "";

                this.focusInput();

                var r = this.suggestQuestList.filter(x => x.uid == uid);
                if (r != null && r.length > 0) {
                    r[0].isFavorite = true;
                }
            },

            getOriginalQuestItem(uid) {
                return this.internalAvailableQuestList.filter(item => item.uid == uid)[0]
            },

            enableAddNewGuestModal() {
                this.$store.commit('showAddNewGuestModal');
                this.showSuggestList = false;
                this.mouserOverSuggestList = false;
            },

            focusInput() {
                this.$refs.requestSearchInput.$refs.searchInputRef.focus();
            }
        }
    }
</script>
<style lang="scss">

    .hide-quest-list{
        display: none !important;
    }

    .addquest {
        padding: 10px;
        position: relative;


        &__label {
            font-weight: 600;
            font-size: 14px;
            line-height: 145%;
            color: #00082c;
            margin-bottom: 8px;
        }

        &__input-text {
            padding: 12.5px 16px;
            background: #ffffff;
            border: 1px solid #d1d6df;
            box-sizing: border-box;
            box-shadow: 1px 1px 3px rgba(0, 8, 44, 0.06);
            border-radius: 4px;
            width: 100%;
            height: 56px;
            font-size: 16px;
            color: #00082c;
        }

        .addquest-autocomplete-list {
            background: #fff;
            position: absolute;
            z-index: 99;
            top: 87%;
            left: 0;
            right: 0;
            display: flex;
            flex-direction: column;
            margin: 0px 10px;
            column-gap: 10px;
            border-bottom: 1px solid #dde0e7;
            border-left: 1px solid #dde0e7;
            border-right: 1px solid #dde0e7;
            max-height: 55vh;
            -webkit-box-shadow: 1px 7px 9px 0px rgba(177, 177, 177, 1);
            -moz-box-shadow: 1px 7px 9px 0px rgba(177, 177, 177, 1);
            box-shadow: 1px 7px 9px 0px rgba(177, 177, 177, 1);

            .add-new-guest {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 10px 0px;
                border-bottom: 1px solid #d1d6df;

                .addquest-button {
                    padding: 5px 10px;
                    margin-right: 5px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    border: 0px;
                    transition: all 0.2s ease-in-out;

                    .button-image {
                        height: 20px;
                        margin: 0px 5px 0px 0px;
                    }

                    &__white {
                        background: #fff;
                        border: 1px solid #bbc2ce;

                        &:hover {
                            background: #e8ebef;
                        }
                    }
                }
            }

            .addquest-autocomplete-list-item {
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                padding: 2px 0px;
                cursor: pointer;

                &:nth-child(even) {
                    background: #f2f2f2;
                }

                .user-favourite-icon-empty {
                    height: 20px;
                    float: right;
                    display: none;
                }

                &:hover {
                    background: #ddd;
                }

                &:hover .user-favourite-icon-empty {
                    display: block;
                }

                .addquest-autocomplete-list-item-user-avatar {
                    margin-left: 5px;
                    flex-grow: 1;

                    .addquest-autocomplete-list-item-user-avatar-img {
                        width: 60px;
                        float: left;
                        padding: 0px 5px 5px 0px;
                    }
                }

                .addquest-autocomplete-list-item-user-data {
                    display: flex;
                    flex-direction: column;
                    row-gap: 0px;
                    width: 100%;
                    margin: 5px 10px;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 132%;
                    color: #00082c;
                    overflow-wrap: break-word;

                    .addquest-autocomplete-list-item-user-data-username{
                        display: flex;
                    } 
                    .user-favourite-icon {
                        height: 20px;
                        float: right;
                    }

                    .addquest-autocomplete-list-item-user-data-role {
                        font-size: 12px;
                        font-weight: normal;
                        color: #5c5c5c;
                        margin-bottom: 10px;
                    }

                    .highlite {
                        color: #000;
                        background: #9eb8ff;
                    }
                }
            }
        }

        .addquest-autocomplete-list-item-user-data-function {
            display: flex;
            flex-direction: row;

            .addquest-button {
                padding: 5px 10px;
                margin-right: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 4px;
                border: 0px;
                transition: all 0.2s ease-in-out;

                .button-image {
                    height: 20px;
                }

                &__white {
                    background: #fff;
                    border: 1px solid #bbc2ce;

                    &:hover {
                        background: #e8ebef;
                    }
                }


                &__red {
                    background: #d80418;
                    color: #fff;

                    .button-image {
                        filter: brightness(0) invert(1);
                    }

                    &:hover {
                        background: #ad0313;
                    }
                }
            }
        }
    }
</style>